<template>
  <!-- Page-header end -->
  <div class="project-page-wrapper">
    <modal-wrapper modalId="riskCalc" hide-footer :withCrossButton="false" title="Расчёт рисков" dialogClass="overlay">
      <div class="overlay__body">
        <div v-if="statusMessage && statusMessage.text == 'Возникла ошибка'">
          <p class="error-status">
            Возникла непредвиденная ошибка. Информация об ошибке уже передана в службу технической поддержки. В
            ближайшее время она будет устранена и мы оповестим Вас по электронной почте.
          </p>
        </div>
        <div v-else class="calculation">
          <h3 class="calculation__title">Выполняется расчёт...</h3>
        </div>
        <p id="cancel-label" class="calculation__status">
          {{ statusMessage ? statusMessage.text : "" }}
          {{ statusMessage ? Math.round(statusMessage.percent) : "" }}%
        </p>
        <center>
          <b-progress :max="100" class="progress">
            <b-progress-bar :value="statusMessage ? statusMessage.percent : 0" class="progress__bar"> </b-progress-bar>
          </b-progress>
        </center>
      </div>
      <div class="overlay__footer">
        <button
          class="cancel-button"
          v-if="statusMessage && statusMessage.text != 'Отменяется' && statusMessage.text != 'Возникла ошибка'"
          ref="cancel"
          @click="calculateCancel()"
        >
          Отменить
        </button>
      </div>
    </modal-wrapper>
    <loading :active.sync="loading" :is-full-page="true"></loading>
    <div class="project-page">
      <!-- Новая версия -->
      <div class="project-menu">
        <ProjectMenuHead
          @onCalculateClick="handleCalculateClick"
          @onIconClick="handleIconClick"
          :readyToCalculate="readyToCalculate"
          :project="project"
          @onCalculateResultClick="$bvModal.show('calcResults')"
          @onСalcErrorsClick="$bvModal.show('calcErrors')"
        />
        <ProjectMenuObjects @onObjectButtonClick="handleObjectButtonClick">
          <!-- Установки -->
          <main-installations
            :action.sync="action"
            ref="installations"
            @clearCalculations="clearCalculations()"
            @editDot="$refs.map.$refs.installationToMap.show()"
            @openSubstanceEditor="
              $refs.substances.show();
              substanceToShow = $event;
            "
            :temp.sync="temp"
            :project="project"
            :substrate="substrate"
            :installations.sync="installations"
            :clearCurrentInstallation="clearCurrentInstallation"
            :oldData.sync="oldData"
          />

          <!-- Трубопроводы -->
          <main-pipelines
            ref="pipelines"
            :action.sync="action"
            @clearCalculations="clearCalculations()"
            @editDot="$refs.map.$refs.installationToMap.show()"
            @openSubstanceEditor="
              $refs.substances.show();
              substanceToShow = $event;
            "
            :temp.sync="temp"
            :project="project"
            :substrate="substrate"
            :pipelines.sync="pipelines"
          />

          <!-- Обвалования -->
          <main-dikings
            ref="dikings"
            :action.sync="action"
            @clearCalculations="clearCalculations()"
            @dikingEdit="$refs.map.dikingEdit($event)"
            @editDot="$refs.map.$refs.dikingToMap.show()"
            :temp.sync="temp"
            :project="project"
            :dikings.sync="dikings"
          />

          <!-- Противопожарные стены -->
          <main-firewalls
            ref="firewalls"
            @clearCalculations="clearCalculations()"
            :action.sync="action"
            @firewallEdit="$refs.map.firewallEdit($event)"
            :firewalls.sync="firewalls"
            :temp.sync="temp"
            :project="project"
          />

          <!-- Твердая горючая нагрузка -->
          <main-solids
            :action.sync="action"
            ref="solids"
            @clearCalculations="clearCalculations()"
            @editDot="$refs.map.$refs.solidToMap.show()"
            :temp.sync="temp"
            :project="project"
            :solids.sync="solids"
            :clearCurrentSolid="clearCurrentSolid"
          />

          <!-- Персонал -->
          <main-people
            @clearCalculations="clearCalculations()"
            :clearCurrentPeople="clearCurrentPeople"
            :legalIndRisk="legalIndRisk"
            :action.sync="action"
            @editDot="$bvModal.show('peopleToMap')"
            :temp.sync="temp"
            :project="project"
            :people.sync="people"
            :oldData.sync="oldData"
          />

          <!-- Селитебные объекты -->
          <main-social
            @socialCreated="$refs.map.socialCreated()"
            @socialEdit="fetchData()"
            @clearCalculations="clearCalculations()"
            :legalResSocRisk="legalResSocRisk"
            :legalResIndRisk="legalResIndRisk"
            :action.sync="action"
            :temp.sync="temp"
            :project="project"
            :socials="socials"
          />
        </ProjectMenuObjects>
      </div>

      <mapeditor
        @clearCalculations="clearCalculations()"
        :showErrors="showPipelineErrors"
        @newSolid="$refs.solids.newSolidWindow($event)"
        @showPipelineNewWindow="$refs.pipelines.newPipeline($event)"
        :project="project"
        :substrate.sync="substrate"
        :analyse="analyse"
        ref="map"
        :id="parseInt($route.params.id)"
        :action.sync="action"
        :pipelines.sync="pipelines"
        :installations.sync="installations"
        :people.sync="people"
        :residential.sync="socials"
        :firewalls.sync="firewalls"
        :solids.sync="solids"
        :dikings.sync="dikings"
        :temp.sync="temp"
        :layers="layers"
        :iconsScale="Number(project.iconsScale)"
        :inModulation.sync="inModulation"
        :loading="loading"
        :tourStep="tourStep"
        :zonesImage.sync="zonesImage"
        :oldData.sync="oldData"
        :legalIndRisk="legalIndRisk"
        :getZones="getZones"
      />
    </div>

    <b-modal id="calcErrors" ref="calcErrors" hide-footer title="Недостаточно данных">
      <span v-if="project.errors">
        <h4 v-if="project.errors.substance">Вещества:</h4>
        <div v-if="project.errors.substance">
          <div :key="sub_error.substance_id" v-for="sub_error in project.errors.substance">
            <b-card v-if="sub_error.substance_name" class="mb-3">
              <h3>
                {{ sub_error.substance_name
                }}<b-btn
                  variant="success"
                  size="sm"
                  class="pull-right"
                  @click="
                    $refs.calcErrors.hide();
                    $refs.substances.show();
                    substanceToShow = {
                      id: sub_error.substance_id,
                      type: sub_error.substance_type,
                    };
                  "
                  >Перейти</b-btn
                >
              </h3>
              <b-list-group>
                <b-list-group-item :key="index" v-for="(error, index) in Object.values(sub_error.errors)"
                  >{{ index + 1 }}. {{ error[0] }}</b-list-group-item
                >
              </b-list-group>
            </b-card>
            <b-card v-else> У одного или нескольких объектов не найдено вещество </b-card>
          </div>
        </div>

        <h4 v-if="project.errors.objects">Оборудование:</h4>
        <div v-if="project.errors.objects">
          <div :key="obj_error.obj_name" v-for="obj_error in project.errors.objects">
            <b-card class="mb-3">
              <h3>{{ obj_error.obj_name }}</h3>
              <b-list-group>
                <b-list-group-item :key="`key-${index}`" v-for="(error, index) in Object.values(obj_error.errors)"
                  >{{ index + 1 }}. {{ error[0] }}</b-list-group-item
                >
              </b-list-group>
            </b-card>
          </div>
        </div>
      </span>
      <span v-else>
        Возникла непредвиденная ошибка. Информация об ошибке уже передана в службу технической поддержки. В ближайшее
        время она будет устранена и мы оповестим Вас по электронной почте.
      </span>
    </b-modal>

    <result-modal
      :legalResIndRisk="legalResIndRisk"
      :legalIndRisk="legalIndRisk"
      :legalResSocRisk="legalResSocRisk"
      :project="project"
      :toNormal="toNormal"
    />

    <create-project-modal title="Настройки проекта" :project.sync="project" @clearCalculations="clearCalculations()" />

    <b-modal
      id="substances"
      ref="substances"
      dialog-class="modal-fullscreen-dialog"
      content-class="modal-fullscreen-content"
      hide-footer
      title="Редактор веществ"
    >
      <substances
        :proj_id="Number(project.id)"
        :substanceToShow.sync="substanceToShow"
        :installations="installations"
        :pipelines="pipelines"
      ></substances>
    </b-modal>
    <b-modal id="cities" size="xl" hide-footer title="Редактор городов">
      <cities></cities>
    </b-modal>

    <modal-wrapper
      dialogClass="report-settings-modal"
      @onCancelClick="$bvModal.hide('editDescription')"
      modalId="editDescription"
      hide-footer
      title="Анализ пожарной опасности"
    >
      <description
        @onCancelClick="$bvModal.hide('editDescription')"
        :fetchData="fetchData"
        :project.sync="project"
        @descriptionHide="$bvModal.hide('editDescription')"
      />
    </modal-wrapper>

    <modal-wrapper
      dialogClass="report-settings-modal"
      modalId="measures"
      hide-footer
      title="Дополнительные мероприятия"
      @onCancelClick="$bvModal.hide('measures')"
    >
      <measures
        @clearCalculations="clearCalculations()"
        @onCancelClick="$bvModal.hide('measures')"
        :project.sync="project"
        @measuresHide="$bvModal.hide('measures')"
      ></measures>
    </modal-wrapper>

    <!-- Настройки отчета -->
    <modal-wrapper
      scrollable
      dialogClass="report-settings-modal"
      modalId="reportSettings"
      hide-footer
      title="Настройки отчёта"
      @onCancelClick="$bvModal.hide('reportSettings')"
    >
      <reportSettings
        @onCancelClick="$bvModal.hide('reportSettings')"
        :project.sync="project"
        :people.sync="people"
        @hide="$bvModal.hide('reportSettings')"
      />
    </modal-wrapper>

    <modal-wrapper
      dialogClass="not-ready-modal"
      modalId="notReady"
      hide-footer
      title="Ошибка расчёта"
      @onCancelClick="$bvModal.hide('notReady')"
    >
      <not-ready :errors="readyToCalculate.errors" @onCancelClick="$bvModal.hide('notReady')" />
    </modal-wrapper>

    <!-- toasts -->
    <custom-toast :key="id" v-for="{ content, title, id } in toasts" :content="content" :title="title" :toastId="id" />

    <v-tour name="newProjInsideTour" :steps="steps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>

<style>
fieldset {
  border: unset !important;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4) !important;
  pointer-events: none;
}
.other-button {
  padding: 0.2rem !important;
}
</style>

<script>
import mapeditor from "./mapeditor";
import Loading from "vue-loading-overlay";
import CreateProjectModal from "../../components/modals/CreateProjectModal.vue";
import substances from "./substances/substances";
import description from "./description";
import measures from "./measures/measures";
import cities from "./cities/cities";
import ProjectMenuHead from "../../components/ProjectMenuHead.vue";
import ProjectMenuObjects from "../../components/ProjectMenuObjects.vue";
import reportSettings from "./reportSettings";
import { newProjectInsideAlice } from "./aliceMixins/newProjectInside";
import Installations from "../../components/installations/Installations";
import Pipelines from "../../components/pipelines/Pipelines";
import Dikings from "../../components/dikings/Dikings";
import Firewalls from "../../components/firewalls/Firewalls";
import Solids from "../../components/solids/Solids";
import People from "../../components/people/People";
import Social from "../../components/social/Social";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import CustomToast from "../../components/ui/CustomToast.vue";
import ModalWrapper from "../../components/modals/ModalWrapper.vue";
import ResultModal from "../../components/modals/ResultModal.vue";
import projectIsNotReady from "./projectIsNotReady.vue";

export default {
  name: "Risk",
  props: {
    clickButton: Object,
  },
  mixins: [newProjectInsideAlice],
  data() {
    return {
      analyse: {
        factor: 0,
        filter: {},
      },
      tabIndex: 0,
      substrate: {},
      project: {},
      installations: [],
      pipelines: [],
      people: [],
      residential: [],
      dikings: [],
      socials: [],
      firewalls: [],
      solids: [],
      action: "do_nothing",
      loading: true,
      temp: {},
      result: null,
      menuHeadTimer: null,
      menuHeadHeight: 500,
      toogleButtons: false,
      toogleButtonsComponents: false,
      toogleButtonsMap: false,
      substanceToShow: {},
      oldData: false,
      layers: {
        substrate: 1,
        installations: 1,
        pipelines: 1,
        dikings: 1,
        people: 1,
        buildings: 1,
        zones: 1,
        firewalls: 1,
        solid: 1,
      },
      inModulation: false,
      zonesImage: null,
      calculationTimer: null,
      modalTimer: null,
      statusMessage: {
        text: null,
        percent: 10,
      },
      clearCurrentInstallation: false,
      clearCurrentSolid: false,
      clearCurrentPeople: false,
      toasts: [
        {
          title: "Добавить трубопровод",
          content: "Теперь отметьте точки прохождения трубопровода",
          id: "new-pipeline-toast",
        },
        {
          title: "Укажите на карте границы стены",
          content: "Добавьте первую точку",
          id: "new-firewalls-toast",
        },
        {
          title: "Укажите на карте границы обвалования",
          content: "Добавьте первую точку",
          id: "new-dikings-toast",
        },
        {
          title: "Укажите на карте границы участка с твердой нагрузкой",
          content: "Добавьте первую точку",
          id: "new-solids-toast",
        },
        {
          title: "Добавить здание",
          content: "Теперь отметьте точку где находится здание",
          id: "new-social-toast",
        },
        {
          title: "Добавить путь",
          content: "Теперь отметьте точки проходит путь",
          id: "new-road-toast",
        },
      ],
    };
  },
  components: {
    mapeditor,
    Loading,
    CreateProjectModal,
    substances,
    description,
    measures,
    cities,
    reportSettings,
    ProjectMenuHead,
    ProjectMenuObjects,
    "main-installations": Installations,
    "main-pipelines": Pipelines,
    "main-dikings": Dikings,
    "main-firewalls": Firewalls,
    "main-solids": Solids,
    "main-people": People,
    "main-social": Social,
    "not-ready": projectIsNotReady,
    CustomToast,
    ModalWrapper,
    ResultModal,
  },
  computed: {
    readyToCalculate() {
      var countObj = 0;
      var onMap = 0;
      var errors = {};
      if (!this.substrate || !this.substrate.substrate_name) {
        errors.substrate = true;
      }
      if (!this.substrate || !this.substrate.k) {
        errors.size = true;
      }
      if (this.installations) {
        for (let inst of this.installations) {
          if (inst.exclude == 0) {
            if (inst.mapObjects) {
              for (let mapObject of inst.mapObjects) {
                if (mapObject.exclude == 0) {
                  onMap++;
                }
              }
            }
            countObj++;
          }
        }
      }
      if (this.pipelines) {
        for (let pipe of this.pipelines) {
          if (pipe.exclude == 0) {
            onMap++;
            countObj++;
          }
        }
      }
      if (countObj == 0) {
        errors.count = true;
        //errors.push('Создайте хотя бы одну технологическую установку или трубопровод.')
      }
      if (onMap == 0) {
        errors.onMap = true;
        //errors.push('Разместите хотя бы одну технологическую установку или трубопровод на подложке.')
      }
      if (Object.keys(errors).length === 0 && errors.constructor === Object) {
        return { status: 1 };
      } else {
        return { status: 0, errors: errors };
      }
    },
    onMap() {
      for (var i = 0; i < this.installations.length; i++) {
        if (this.installations[i].mapObjects) {
          return true;
        }
      }
      return false;
    },
    legalIndRisk() {
      if (this.project.increaseRisk == 1) {
        return 0.0001;
      } else {
        return 0.000001;
      }
    },
    legalResIndRisk() {
      if (this.project.increaseSRisk == 1) {
        return 0.000001;
      } else {
        return 0.00000001;
      }
    },
    legalResSocRisk() {
      if (this.project.increaseSRisk == 1) {
        return 0.00001;
      } else {
        return 0.0000001;
      }
    },
  },
  watch: {
    clickButton() {
      this.temp = {};
      this.action = "do_nothing";
      this.$refs.map.clearAll();
    },
    "analyse.factor"() {
      this.getZones();
    },
  },
  created() {
    document.documentElement.scrollIntoView(true);
    this.fetchData();
  },

  methods: {
    handleIconClick(buttonName) {
      if (buttonName === "project-menu") {
        this.openCreateProjectModal();
      }
      if (buttonName === "settings") {
        this.$bvModal.show("reportSettings");
      }
      if (buttonName === "additional-activities") {
        this.$bvModal.show("measures");
      }
      if (buttonName === "analysis") {
        this.$bvModal.show("editDescription");
      }
    },

    showPipelineErrors(errors) {
      this.project.errors = { ...this.project.errors, substance: errors };
      this.$bvModal.show("calcErrors");
    },

    handleCalculateClick() {
      if (!this.readyToCalculate.status || this.readyToCalculate.status == 0) {
        this.$bvModal.show("notReady");
      } else {
        this.calculate();
      }
    },

    handleObjectButtonClick(tabIndex) {
      this.tabIndex = tabIndex;
      if (tabIndex === 0) {
        this.clearCurrentInstallation = !this.clearCurrentInstallation;
        this.$bvModal.show("addInstallation");
      }
      if (tabIndex === 1) {
        this.action = "newPipeline";
        this.showToast("new-pipeline-toast");
      }
      if (tabIndex === 2) {
        this.$refs.dikings.dikingAdd();
      }
      if (tabIndex === 3) {
        this.clearCurrentPeople = !this.clearCurrentPeople;
        this.$bvModal.show("personAdd");
      }
      if (tabIndex === 4) {
        this.$bvModal.show("socialTypeModal");
      }
      if (tabIndex === 5) {
        this.$refs.firewalls.firewallAdd();
      }
      if (tabIndex === 6) {
        this.clearCurrentSolid = !this.clearCurrentSolid;
        this.$refs.solids.solidAdd();
      }
    },

    showToast(id) {
      this.$bvToast.show(id);
    },

    hasHistory() {
      return window.history.length > 2;
    },

    click(e) {
      alert(e);
    },
    getImage(name) {
      return require("../../assets/icons/" + name + ".png");
    },
    optimy() {
      this.$http
        .get("risk/optimisation/test", {
          params: {
            proj_id: this.project.id,
          },
        })
        .then(() => {})
        .catch(() => {
          this.project.status = 3;
        });
    },
    clearCalculations() {
      this.project.result = null;
      this.project.status = 0;
      this.zonesImage = null;
    },
    fecthStatus() {
      clearTimeout(this.modalTimer);
      this.$http
        .get("risk/get-status", {
          params: {
            proj_id: this.project.id,
          },
        })
        .then((response) => {
          if (response.data && response.data.project) {
            this.loading = true;
            this.$set(this, "oldData", false);
            clearInterval(this.calculationTimer);
            this.result = response.data.html;
            this.project.status = response.data.project.status;
            this.$set(this, "project", response.data.project);
            if (this.project.result && this.project.result.zonesUrl) {
              this.zonesImage = this.project.result.zonesUrl;
            }
            this.installations = this.filterById(response.data.installations, this.project.id);
            this.pipelines = response.data.pipelines;
            this.people = this.filterById(response.data.people, this.project.id);
            this.socials = response.data.socials;
            this.dikings = response.data.dikings;
            this.firewalls = response.data.firewalls;
            this.statusMessage = { text: "Расчет выполнен", percent: 100 };
            this.$refs.map.analyse.factor = 0;
            this.$bvModal.hide("riskCalc");
            this.$nextTick(() => {
              this.loading = false;
            });
          } else if (!response.data) {
            if (this.statusMessage.text == "Возникла ошибка") {
              this.project.status = 3;
            } else {
              this.project.status = 0;
            }
            this.statusMessage = null;
            clearInterval(this.calculationTimer);
          } else {
            if (
              !(
                this.statusMessage &&
                (this.statusMessage.text == "Отменяется" || this.statusMessage.text == "Возникла ошибка")
              )
            ) {
              this.statusMessage = response.data;
            }
          }
        })
        .catch(() => {
          this.project.status = 3;
          clearInterval(this.calculationTimer);
        })
        .finally(() => {
          this.modalTimer = setTimeout(() => this.$bvModal.hide("riskCalc"), 3000);
        });
    },
    getStatus() {
      this.calculationTimer = setInterval(() => {
        this.fecthStatus();
      }, 1500);
    },
    calculateCancel() {
      this.statusMessage = { text: "Отменяется", percent: 0 };
      this.$http
        .get("risk/calculate-cancel", {
          params: {
            proj_id: this.project.id,
          },
        })
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.$bvModal.hide("riskCalc");
        });
    },
    energyOn() {
      this.loading = true;
      this.$http
        .get("risk/calculate", {
          params: {
            proj_id: this.project.id,
            eon: true,
          },
        })
        .then((response) => {
          this.result = response.data.html;
          this.loading = true;
          this.$set(this, "oldData", false);
          this.zonesImage = response.data.zonesUrl;
          this.people = this.filterById(response.data.people, this.project.id);
          this.socials = response.data.socials;
          this.$nextTick(() => {
            this.loading = false;
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    calculate() {
      this.project.status = 1;
      this.$http
        .get("risk/calculate", {
          params: {
            proj_id: this.project.id,
          },
        })
        .then(() => {
          this.fecthStatus();
          this.statusMessage = { text: "Инициализация", percent: 0 };
          this.$bvModal.show("riskCalc");
          this.getStatus();
        })
        .catch(() => {
          this.loading = false;
          this.project.status = 3;
        });
    },
    filterById(array, id) {
      if (!array || !array.length) return;
      return array.map((item) => {
        if (item.mapObjects) {
          item.mapObjects = item.mapObjects.filter((object) => object.proj_id == id);
        }
        return item;
      });
    },
    fetchData() {
      this.loading = true;
      this.$http
        .get("risk/open?id=" + this.$route.params.id)
        .then((response) => {
          const projectId = response.data.project.id;
          this.substrate = response.data.substrate;

          this.$set(this, "project", response.data.project);
          if (this.project.result && this.project.result.zonesUrl) {
            this.zonesImage = this.project.result.zonesUrl;
          }
          this.installations = this.filterById(response.data.installations, projectId);
          this.pipelines = response.data.pipelines;
          this.people = this.filterById(response.data.people, projectId);
          this.socials = response.data.socials;
          this.dikings = response.data.dikings;
          this.firewalls = response.data.firewalls;
          this.solids = response.data.solids;
          if (this.project.status == 1) {
            this.fecthStatus();
            this.getStatus();
          }

          this.$nextTick(() => {
            this.loading = false;
          });
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.license) {
            alert(e.response.data.license);
            this.$parent.$router.push({
              path: "/",
              query: { nolicense: true },
            });
          }
          console.error(e);
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    getZones() {
      this.inModulation = true;
      if (this.project.result.zonesUrl && this.analyse.factor == 0) {
        this.zonesImage = this.project.result.zonesUrl;
        this.inModulation = false;
        return;
      }
      this.$http
        .post("risk/objects/get-factors-areas?proj_id=" + this.project.id + "&factor=" + this.analyse.factor, {
          filter: this.analyse.filter,
        })
        .then((response) => {
          this.$set(this, "zonesImage", response.data);
          this.inModulation = false;
        })
        .catch(() => {
          this.inModulation = false;
        });
    },

    // Возвращает формат "0.00*10<sup>-5</sup>"
    toNormal(val) {
      if (String(val).includes("e-")) {
        val = String(val);
        val = val.split("e-");
        return parseFloat(val[0]).toFixed(2) + "*10<sup>-" + val[1] + "</sup>";
      } else {
        val = String(val);
        let multiply = 0;
        for (const i in val) {
          if (val[i] == "0" || val[i] == ".") {
            multiply++;
          } else {
            break;
          }
        }
        if (multiply > 1) {
          val = val * Math.pow(10, multiply - 1);
          parseFloat(val).toFixed(2);
          return Math.floor(val * 100) / 100 + "*10<sup>-" + (multiply - 1) + "</sup>";
        } else {
          return parseInt(val).toFixed(2);
        }
      }
    },

    getInstallationImage(type) {
      type = parseInt(type);
      switch (type) {
        case 1:
          return require("../../assets/icons/tank.png");
        case 2:
          return require("../../assets/icons/tank.png");
        case 3:
          return require("../../assets/icons/hori.png");
        case 4:
          return require("../../assets/icons/oiltrack.png");
        case 5:
          return require("../../assets/icons/oilrailwattank.png");
        case 6:
          return require("../../assets/icons/oiltrack.png");
        case 7:
          return require("../../assets/icons/oilrailwattank.png");
        case 11:
          return require("../../assets/icons/nar.png");
        case 12:
          return require("../../assets/icons/nar.png");
        case 13:
          return require("../../assets/icons/nar.png");
        case 31:
        case 32:
        case 33:
          return require("../../assets/icons/pump.png");
        case 21:
        case 22:
        case 23:
          return require("../../assets/icons/fueldispenser.png");
        case 14:
        case 15:
        case 16:
          return require("../../assets/icons/ballgas.png");
        case 17:
        case 19:
          return require("../../assets/icons/wallPad.png");
        case 41:
          return require("../../assets/icons/pipeMag.png");
        case 42:
          return require("../../assets/icons/pipeMag.png");
        case 43:
          return require("../../assets/icons/pipeMag.png");
        case 44:
          return require("../../assets/icons/pipeTech.png");
        case 45:
          return require("../../assets/icons/pipeTech.png");
        case 46:
          return require("../../assets/icons/pipeTech.png");
        case 51:
          return require("../../assets/icons/chemical.png");
        case 34:
          return require("../../assets/icons/candle.png");
        default:
          return require("../../assets/icons/vertical_tank.svg");
      }
    },

    openCreateProjectModal() {
      this.$bvModal.show("new-project");
    },
  },
};
</script>
<style>
.project-page-wrapper {
  height: 100%;
}
.project-page {
  position: relative;
  display: grid;
  grid-template-columns: 6fr 16fr;
  height: 100%;
  max-height: calc(100vh - 64px);
  width: 100%;
  overflow: auto;
  padding-right: 37px;
  padding-bottom: 16px;
  padding-top: 16px;
}
.project-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 27px 0 32px;
  min-width: 370px;
  overflow-y: auto;
}
.latest-update-card .card-block .latest-update-box:after {
  left: 30px;
}
.latest-update-card .card-block .latest-update-box .update-meta {
  z-index: 2;
  min-width: 0px;
}
.modal-fullscreen > div {
  padding: 16px !important;
}
.modal-fullscreen-dialog {
  width: 100%;
  max-width: 99999px;
  height: 100%;
  margin: 0;
  padding: 16px;
}

.modal-fullscreen-content {
  height: auto;
  min-height: 100%;
  border: 0 none;
  border-radius: 0;
}
.report-settings-modal {
  max-width: 900px;
}
.not-ready-modal {
  max-width: 600px;
}

.calculation__title {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 24px;
  color: var(--black-color);
}
.calculation__status {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
  color: var(--black-color);
}
.progress {
  width: 340px;
  height: 8px;
  border-radius: 8px;
  margin-bottom: 24px;
  background-color: #d9d9d9;
}
.progress__bar {
  background-color: var(--primary-color);
  border-radius: 8px;
}

.cancel-button {
  padding: 10px 24px;
  background-color: var(--error-color);
  border-radius: 4px;
  color: var(--white-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  font-family: "Inter", sans-serif;
  border: none;
}
.cancel-button:hover {
  background-color: var(--red-5-color);
}

.error-status {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
  color: var(--black-color);
}

.overlay__body {
  padding: 0 32px 32px 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.overlay__footer {
  background-color: var(--background-color);
  padding: 16px 24px;
}
</style>
